/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconGenderDemigirl = createReactComponent("gender-demigirl", "IconGenderDemigirl", [
  ["path", { d: "M12 9m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", key: "svg-0" }],
  ["path", { d: "M12 14v7", key: "svg-1" }],
  ["path", { d: "M9 18h3", key: "svg-2" }]
]);

export { IconGenderDemigirl as default };
//# sourceMappingURL=IconGenderDemigirl.js.map
